import { html, LitElement, unsafeCSS } from 'lit';
import { property } from 'lit/decorators/property.js';
import { customElement } from 'lit/decorators/custom-element.js';
import imageCSS from './bg-image.scss?inline';
import { getImage, ImgInterface } from '../../library/images.ts';

@customElement('bg-image')
export class BgImage extends LitElement {
    @property()
    docsHint = '';

    @property()
    alt: string = '';

    @property()
    src: string = '';

    @property({ type: String })
    lazy: string = "true";
    
    @property({ type: String })
    fetchpriority?: string = "low";

    @property({ attribute: 'medium' })
    mediumSrc: string = '';

    @property({ attribute: 'large' })
    largeSrc: string = '';

    @property({ attribute: 'xlarge' })
    xLargeSrc: string = '';

    @property({ attribute: 'img-class' })
    imgClass?: string = '';

    constructor(args: ImgInterface) {
        super();
        if (!args) {
            return;
        }

        this.alt = args.alt;
        this.src = args.src;
        this.lazy = args.lazy;
        this.fetchpriority = args.fetchpriority;
        this.mediumSrc = args.mediumSrc;
        this.largeSrc = args.largeSrc;
        this.xLargeSrc = args.xLargeSrc;
        this.imgClass = args.imgClass;
    }

    getImageData = () => {
        return {
            alt: this.alt,
            src: this.src,
            lazy: this.lazy,
            fetchpriority: this.fetchpriority,
            mediumSrc: this.mediumSrc,
            largeSrc: this.largeSrc,
            xLargeSrc: this.xLargeSrc,
            imgClass: this.imgClass
        } as ImgInterface;
    };

    render = () => {
        if (!this.src) {
            return;
        }

        const img = this.getImageData();
        return html`${getImage(img)}`;
    };

    static styles = unsafeCSS(imageCSS);
}

declare global {
    interface HTMLElementTagNameMap {
        'bg-image': BgImage;
    }
}
